import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
//import images
import customer from "views/job-details/img/key/customer.png";
import business from "views/job-details/img/key/business.png";
import shopping from "views/job-details/img/key/shopping.png";
import folder from "views/job-details/img/key/folder.png";
// install Swiper modules

SwiperCore.use([Pagination, Navigation]);

export default function App() {
  return (
    <>
      <div className="flex justify-between items-center  mb-8">
        <div>
          <h2 className="fsize28 text424B5A font-bold">
            Benefits of working at icici careers
          </h2>
          <p className="text424B5A fsize18 mt-4">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium
          </p>
        </div>

        <div className="flex ">
          <ChevronLeft
            width="30px"
            height="30px"
            className="trend-left-i mr-2 disabled"
          />
          <ChevronRight width="30px" height="30px" className="trend-right-i" />
        </div>
      </div>
      <Swiper
        slidesPerView={4}
        spaceBetween={15}
        slidesPerGroup={4}
        loop={true}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        className="mySwiper swiperpagination-dot "
      >
        <SwiperSlide className=" p-2 block">
          <div className="dropshadow-md rounded-12px p-6">
            <img src={customer} className="key-img-w" />
            <div className="text-left mt-6">
              <h1 className="font-bold fsize20 text-black">Customer Service</h1>
              <p className="fsize18 text4B4B4B pt-2 line-h26px">
                Create service excellence by being a banker of choice to the
                customer
              </p>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className=" p-2 block">
          <div className="dropshadow-md rounded-12px p-6">
            <img src={business} className="key-img-w" />
            <div className="text-left mt-6">
              <h1 className="font-bold fsize20 text-black">
                Business Development
              </h1>
              <p className="fsize18 text4B4B4B pt-2 line-h26px">
                Onboard new customers to the bank and enhance walletshare of
                customers
              </p>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className=" p-2 block">
          <div className="dropshadow-md rounded-12px p-6">
            <img src={shopping} className="key-img-w" />
            <div className="text-left mt-6">
              <h1 className="font-bold fsize20 text-black">Cross Sell</h1>
              <p className="fsize18 text4B4B4B pt-2 line-h26px">
                Cross sell bouquet of products & servicesbased on customerneeds
              </p>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className=" p-2 block">
          <div className="dropshadow-md rounded-12px p-6">
            <img src={folder} className="key-img-w" />
            <div className="text-left mt-6">
              <h1 className="font-bold fsize20 text-black">
                Portfolio Quality
              </h1>
              <p className="fsize18 text4B4B4B pt-2 line-h26px">
                Quality of loan book, periodic due diligence of business flows,
                overdue
              </p>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
